import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let MyDialog = class MyDialog extends Vue {
    get isDark() {
        return this.$vuetify.theme.dark;
    }
    get hasTitle() {
        return !!this.$slots.title || !!this.$scopedSlots.title;
    }
    get onCloseFunction() {
        if (this.onClose) {
            return this.onClose;
        }
        return () => { };
    }
};
__decorate([
    Prop(Boolean)
], MyDialog.prototype, "value", void 0);
__decorate([
    Prop(Boolean)
], MyDialog.prototype, "disabled", void 0);
__decorate([
    Prop(Boolean)
], MyDialog.prototype, "wide", void 0);
__decorate([
    Prop(Function)
], MyDialog.prototype, "onClose", void 0);
MyDialog = __decorate([
    Component
], MyDialog);
export default MyDialog;
